import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DepositoNotasCard from './components/DepositoNotasCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const DepositoMain = () => {
  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[{ name: 'Inicio' }, { name: 'Deposito' }]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <DepositoNotasCard />
        </Col>
      </Row>
    </Container>
  );
};

export default DepositoMain;
